// `sage preset` installed this file automatically.
// Running `sage preset` again could result in automatic deletion of this file.
// Because of this, we do not recommend editing this file.
import 'foundation-sites/js/entries/foundation'
import 'foundation-sites/js/entries/foundation-plugins'

jQuery(document).ready($ => ($(document).foundation()));



// WEBPACK FOOTER //
// ./scripts/autoload/_foundation.js